module.exports = __webpack_public_path__ + "static/img/hzhb_xxpl_banner.cd49485.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_xxpl_banner.png
// module id = 53Ls
// module chunks = 0